// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_fv-7";
export var emphasizeQuantity = "_fv-3";
export var flatBottomCorners = "_fv-5";
export var productImage = "_fv-0";
export var quantityContainer = "_fv-2";
export var quantityHeader = "_fv-6";
export var tooltip = "_fv-1";
export var wrapAndEllipsesOverflow = "_fv-4";